module.exports = __webpack_public_path__ + "img/end.51d05e13.svg";